import { Dispatch, FC } from 'react';
import { useBreakpoints } from '../../../bookings/util/useBreakpoints';
import { useDesktopTopNav } from '../../../common/Experiments/DesktopTopNavExperiment';
import { SearchPromotionItem } from '../../../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { InlineSearch } from '../../InlineSearch/InlineSearch';
import { DesktopHideWrapper } from '../../InlineSearch/SearchSpecialtySelector/SearchSpecialtySelector.styles';
import {
  BannerBackground,
  BannerStaticWrapper,
  HomeBannerPerson,
  HomeHeroCol,
  HomeHeroPageSection,
  BannerElementWrapper,
  HomeHeroHeading,
  HomeHeroSubHeading,
  HomeHeroMobilePromptTitle,
  HomeHeroPageSectionExperiment,
  BannerBackgroundExperiment,
  HomeHeroHeadingExperiment,
  MobileBannerBackground,
  HomeHeroSubHeadingExperiment,
  HomeHeroColExperiment,
} from './HomeHeroSection.styles';

interface HomeHeroSectionProps {
  setSearchSpecialty?: Dispatch<SearchPromotionItem | null>;
  searchSpecialty?: SearchPromotionItem | null;
}

const backgroundElement = (
  <BannerElementWrapper>
    <BannerStaticWrapper>
      <BannerBackground />
      <HomeBannerPerson src="/public/images/_20220302104118.homepage_person" />
    </BannerStaticWrapper>
  </BannerElementWrapper>
);

const backgroundElementExperiment = (
  <BannerElementWrapper>
    <BannerStaticWrapper>
      <BannerBackgroundExperiment />
      <HomeBannerPerson src="/public/images/_20220302104118.homepage_person" />
    </BannerStaticWrapper>
  </BannerElementWrapper>
);

const mobileBackgroundElementExperiment = (
  <BannerElementWrapper>
    <MobileBannerBackground />
  </BannerElementWrapper>
);

export const HomeHeroSection: FC<HomeHeroSectionProps> = ({
  setSearchSpecialty,
  searchSpecialty,
}) => {
  const topNavExperiment = useDesktopTopNav();

  return (
    <HomeHeroPageSection backgroundElement={backgroundElement} topNavExperiment={topNavExperiment}>
      <HomeHeroCol>
        <HomeHeroHeading h1>
          Get better connected <br /> to healthcare
        </HomeHeroHeading>
        <HomeHeroSubHeading h2>
          Healthengine is your home for healthcare, with all your practitioners in one place.
        </HomeHeroSubHeading>
        <HomeHeroMobilePromptTitle h5 small>
          What do you need help with?
        </HomeHeroMobilePromptTitle>
        <InlineSearch onSetSearchSpecialty={setSearchSpecialty} searchSpecialty={searchSpecialty} />
      </HomeHeroCol>
    </HomeHeroPageSection>
  );
};

export const HomeHeroSectionExperiment: FC<HomeHeroSectionProps> = ({
  setSearchSpecialty,
  searchSpecialty,
}) => {
  const isMobile = useBreakpoints().Small;

  return (
    <>
      <HomeHeroPageSectionExperiment
        backgroundElement={
          isMobile ? mobileBackgroundElementExperiment : backgroundElementExperiment
        }
      >
        <HomeHeroColExperiment>
          <HomeHeroHeadingExperiment h1>Find Care. Feel Better.</HomeHeroHeadingExperiment>
          <HomeHeroSubHeadingExperiment h2>
            Book an in-person, phone, or video appointment.
          </HomeHeroSubHeadingExperiment>
          <InlineSearch
            onSetSearchSpecialty={setSearchSpecialty}
            searchSpecialty={searchSpecialty}
            disableSearchBar
            renderGPCards={true}
            renderOtherTiles={!isMobile}
          />
        </HomeHeroColExperiment>
      </HomeHeroPageSectionExperiment>
      <DesktopHideWrapper>
        <InlineSearch
          onSetSearchSpecialty={setSearchSpecialty}
          searchSpecialty={searchSpecialty}
          disableSearchBar
          renderGPCards={false}
          renderOtherTiles={isMobile}
        />
      </DesktopHideWrapper>
    </>
  );
};
